import { render, staticRenderFns } from "./CmsMenu2.vue?vue&type=template&id=782f3fef"
import script from "./CmsMenu2.vue?vue&type=script&lang=js"
export * from "./CmsMenu2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports